import { nextTick } from "vue";
export interface Phrase {
  id: number;
  shorthand: string;
  expanded: string;
  uses: number;
  created_at: string;
  updated_at: string;
  user_id: number;
}

export const insertPhraseIntoTextarea = async (
  textarea: HTMLTextAreaElement,
  textRef: string,
  phrase: Phrase,
) => {
  if (!textarea) return;

  const cursorPosition = textarea.selectionStart;
  const textBeforeCursor = textRef.value.substring(0, cursorPosition);
  const textAfterCursor = textRef.value.substring(cursorPosition);

  const words = textBeforeCursor.split(/\s+/);
  const currentWord = words[words.length - 1];

  let insertionPoint = cursorPosition;
  if (
    currentWord &&
    phrase.shorthand.toLowerCase().includes(currentWord.toLowerCase())
  ) {
    insertionPoint = cursorPosition - currentWord.length;
  }

  textRef.value =
    textRef.value.substring(0, insertionPoint) +
    phrase.expanded +
    " " +
    textAfterCursor;

  await nextTick(() => {
    textarea.focus();
    const newCursorPosition = insertionPoint + phrase.expanded.length + 1;
    textarea.setSelectionRange(newCursorPosition, newCursorPosition);
  });
};

export const getWordAtCursor = (text: string, cursorPos: number) => {
  const textBefore = text.substring(0, cursorPos);
  const textAfter = text.substring(cursorPos);

  const wordStart =
    Math.max(
      textBefore.lastIndexOf(" "),
      textBefore.lastIndexOf("\n"),
      textBefore.lastIndexOf("\t"),
    ) + 1;

  const wordEnd =
    cursorPos +
    Math.min(
      textAfter.indexOf(" ") === -1 ? textAfter.length : textAfter.indexOf(" "),
      textAfter.indexOf("\n") === -1
        ? textAfter.length
        : textAfter.indexOf("\n"),
      textAfter.indexOf("\t") === -1
        ? textAfter.length
        : textAfter.indexOf("\t"),
    );

  return {
    word: text.substring(wordStart, wordEnd),
    start: wordStart,
    end: wordEnd,
  };
};
